"use client";
import TimeConvertForm from "../TimeConvertForm";
import { usePathname } from "@/i18n/navigation";
import DateToTimestamp from "../DateToTimestamp";
import TimestampToDate from "@/components/timeConvertForm/TimestampToDate";

function TimeConvertFormat() {
  const Name = usePathname();

  return (
    <>
      {Name === "/timestamp-to-date" && <TimestampToDate />}
      {Name === "/date-to-timestamp" && <DateToTimestamp />}
      {Name === "/time-convert" && <TimeConvertForm />}
    </>
  );
}

export default TimeConvertFormat;
